import { fromUnixTime, isFuture } from 'date-fns';

export type MatchContumacy = 'home' | 'away' | 'both' | null;

/**
 * A match shows a result instead of its kick-off time once its start has
 * passed, or as soon as it is forfeited – a forfeit is decided regardless of
 * the scheduled date. No GraphQL imports here on purpose: this is used by the
 * OG image route, which runs in the Edge Runtime.
 */
export function isMatchDecided(match: { dateStart: number; contumacy?: string | null }): boolean {
  if (match.contumacy) return true;
  return !isFuture(fromUnixTime(match.dateStart));
}
